import React from 'react';
import UnderConstruction from '../under-development/UnderConstruction';

const Events = () => {
    return <UnderConstruction />;
};

export default Events; 